module.exports = __webpack_public_path__ + "static/img/hs_cj_2.912e858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/hs_cj_2.png
// module id = 4Qec
// module chunks = 1